 import React, { useState, useEffect, useRef} from 'react'
import NavbarReturn from '../components/NavbarReturn';
import FooterAdmin from '../components/FooterAdmin';
import AlertBox from '../components/AlertBox';
import SearchBar from "../components/SearchBar";
import { v4 } from 'uuid';
import { XMarkIcon, CalendarIcon } from "@heroicons/react/24/outline";
import {ArrowUpTrayIcon} from '@heroicons/react/24/outline';
import { storage } from '../config/firebaseConfig';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { collection, getDocs, setDoc, doc, updateDoc, deleteDoc, increment} from "firebase/firestore";
import { database } from "../config/firebaseConfig";
import { Toaster } from 'react-hot-toast';
import AlertOnLoading from '../components/AlertOnLoading';
import { LazyLoadImage } from "react-lazy-load-image-component";

function NewsAdmin() {
    const WAIT_TIME = 1000; //Waits for 2s
    const notInitialRender = useRef(false);

    const SUCCESS = "success"
    const WARNING = "warning"
    const DANGER = "danger"

    const [newData, setNewData] = useState(true); //it functions to validate if it needs to re-render
    const [newDataComments, setNewDataComments] = useState(true); //it functions to validate if it needs to re-render
    const newsCollectionRef = collection(database, "news");

    const [uploading, setUploading] = useState(false);
    const [updating, setUpdating] = useState(false);

    const [imageUpload, setImageUpload] = useState(null);
    const [imageURL, setImageURL] = useState('');

    const [newsIdSelected, setNewsIdSelected]= useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const newsPerPages = 5;

    const [allNews, setAllNews] = useState(null);

    const [newsTitle, setNewsTitle] = useState("");
    const [newsDescription, setNewsDescription] = useState("");
    const [imageSelected, setImageSelected] = useState("Imagen");

    const [isOpen, setIsOpen] = useState(false);
    
    const [selectedNewsComments, setSelectedNewsComments] = useState(null);
    const [selectedComment, setSelectedComment]= useState('');
    
    const lastNewsIndex = currentPage * newsPerPages;
    const firstNewsIndex = lastNewsIndex - newsPerPages;

    const togglePopupDelete = (newsId) =>{
        [].forEach.bind(document.getElementsByClassName(`popup_delete ${newsId}`),function(itm){
          itm.style.display = "flex";
        })();
    }
  
    const closePopupDelete = (newsId) =>{
        [].forEach.bind(document.getElementsByClassName(`popup_delete ${newsId}`),function(itm){
            itm.style.display = "none";
        })();
    }

    function updateText(event) {
        setImageUpload(event.target.files[0]);
        const newText = document.getElementById("uploadImage").value;
        const getFileName = newText.split("\\");
        setImageSelected(getFileName[getFileName.length - 1]);
    }

    /*
        It shows the PopUp of the news
    */
    const togglePopUpNews = (newsId, name, image, description) => {
        const popup = document.getElementById(newsId);
        popup.classList.remove('hidden');
        popup.classList.add('flex');
        setNewsTitle(name);
        setImageURL(image);
        setNewsDescription(description);
        setNewsIdSelected(newsId);
        setImageSelected("Imagen");
    }

    /*
        It hides the PopUp of the news
    */
    const closePopUpNews = (newsId) => {
        const popup = document.getElementById(newsId);
        setNewsTitle('');
        setImageURL('');
        setNewsDescription('');
        setNewsIdSelected('');
        setImageSelected('Imagen');
        popup.classList.add('hidden');
        popup.classList.remove('flex');
    }

    /*
        It updates the text of the image's input for PopUp
    */
    function updateTextPopUp(event) {
        setImageUpload(event.target.files[0]);
        const newText = event.target.files[0];
        const getFileName = newText.name;
        setImageSelected(getFileName);
    }


    /*
        It toggles the PopUp for previewing the news
    */
    const togglePopUp = () => {
        if (isOpen) {
            setIsOpen(!isOpen);

        } else {
            
            if (fieldsFilled()) {
                setIsOpen(!isOpen);
            }
            
        }
        
      }

    /*
        It checks wether the fields for the news are filled
    */
    function fieldsFilled() {
        if (newsTitle === "" || newsDescription === "" || imageUpload === null) {
            AlertBox(WARNING, 'Rellena todos los campos antes de previsualizar la noticia');
            return false;
        }
        return true;
    }

    /*
        Get current date as "DD/MM/YYYY"
    */
    function getCurrentDate() {
        const current = new Date();
        const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
        return date;
    }

    /*
        Checks wether the image is null or not
    */
    function imageNotNull() {

        if (imageUpload) {
            return URL.createObjectURL(imageUpload);

        } else {
            return "";
        }
    }

    /*
        It shows the comments of a given news
    */
    const togglePopUpComments = (newsId) =>{
        [].forEach.bind(document.getElementsByClassName(`popup_comments ${newsId}`),function(itm){
            itm.style.display = "flex";
        })();
        getNewsComments(newsId);
        setNewsIdSelected(newsId);
    }

    const closePopupComments = (newsId) =>{
        [].forEach.bind(document.getElementsByClassName(`popup_comments ${newsId}`),function(itm){
            itm.style.display = "none";
        })();
        setNewsIdSelected("");
    }

    const togglePopUpDeleteComment = (newsId, commentId) =>{
        [].forEach.bind(document.getElementsByClassName(`popup_deletecomment ${newsId}`),function(itm){
            itm.style.display = "flex";
        })();
        setSelectedComment(commentId);
    }

    const closePopupDeleteComment = (newsId) =>{
        [].forEach.bind(document.getElementsByClassName(`popup_deletecomment ${newsId}`),function(itm){
            itm.style.display = "none";
        })();
        setSelectedComment("");
    }

    /*
        Creates a new news document on firebase
    */
    async function createNews() {
        if (newsTitle === "") {
            AlertBox(WARNING, '¡Debe ingresar el título de la noticia!');
            return;

        } else if (imageUpload === null) {
            AlertBox(WARNING, '¡Debe seleccionar una imagen!');
            return;

        } else if (newsDescription === "") {
            AlertBox(WARNING, '¡Debe ingresar una descripción para la noticia!');
            return;

        } else {
            const addButton = document.querySelectorAll("#addRegister");
            addButton[0].setAttribute("disabled", true);

            setUploading(true);

            const imageRef = await ref(storage, `images/${imageUpload.name + v4()}`);
            uploadBytes(imageRef, imageUpload).then(async () => {
    
                const imageURL = await getDownloadURL(imageRef);
                const newNewsRef = doc(newsCollectionRef);
                setDoc(newNewsRef, {title: newsTitle, description:newsDescription, image:imageURL, countComments:0, date:getCurrentDate()});

                setImageSelected("Imagen");
                setNewsTitle("");
                setNewsDescription("");
                setImageUpload(null);
                setNewData(true);

                addButton[0].removeAttribute("disabled");

                setUploading(false);
                
                AlertBox(SUCCESS, 'Noticia creada exitosamente');
                return;
            })
            .catch(error => {
                console.log("Error al subir la imagen ", error);
                addButton[0].removeAttribute("disabled");

                setUploading(false);
                AlertBox(DANGER, '¡Ha ocurrido un error inesperado!');
                return;
            });
        }
    }

    const deleteNumbers = (selectedId) => {
        return selectedId.replace(/\d+/g, '');
    }

    /*
        Updates a news document
    */
    async function updateNews() {
        if (imageSelected !== "Imagen") {
            const updateButton = document.querySelectorAll(`button.${deleteNumbers(newsIdSelected)}`);
            updateButton[0].setAttribute("disabled", true);

            setUpdating(true);

            const imageRef = await ref(storage, `images/${imageUpload.name}`);
            uploadBytes(imageRef, imageUpload).then(async () => {
                const imageURL = await getDownloadURL(imageRef);
                const updateNewsRef = doc(database, 'news', newsIdSelected);
                await updateDoc(updateNewsRef, {title:newsTitle, image: imageURL, description: newsDescription});

                setImageSelected("Imagen");
                setNewsTitle("");
                setNewsDescription("");
                setNewData(true);

                updateButton[0].removeAttribute("disabled");

                setUpdating(false);
                AlertBox(SUCCESS, '¡Noticia actualizada correctamente!');
                closePopUpNews(newsIdSelected);
                return;
            })
            .catch(error => {
                console.log("Error al subir la imagen ", error);
                updateButton[0].removeAttribute("disabled");

                setUpdating(false);
                AlertBox(DANGER, '¡Ha ocurrido un error inesperado!');
                return;
            });
        } else {
            const updateButton = document.querySelectorAll(`button.${deleteNumbers(newsIdSelected)}`);
            updateButton[0].setAttribute("disabled", true);

            setUpdating(true);

            const updateNewsRef = doc(database, 'news', newsIdSelected);
            await updateDoc(updateNewsRef, {title:newsTitle, image: imageURL, description: newsDescription});

            setImageSelected("Imagen");
            setNewsTitle("");
            setNewsDescription("");
            setNewData(true);

            updateButton[0].removeAttribute("disabled");

            setUpdating(false);
            AlertBox(SUCCESS, '¡Noticia actualizada correctamente!');
            closePopUpNews(newsIdSelected);
            return;
        }
        
    }

    /*
        Deletes a news document
    */
    async function deleteNews(newsId) {
        const newsDoc = doc(database, "news", newsId);
        await deleteDoc(newsDoc);
        setNewData(true);
        closePopupDelete(newsId);
        AlertBox(SUCCESS, '¡Noticia eliminada correctamente!');
    }

    /*
        Gets all comments from selected news
    */
    async function getNewsComments(newsId) {
        const commentsCollectionRef = collection(database, "news", newsId, "comments");
        const comments = await getDocs(commentsCollectionRef);
        setSelectedNewsComments(comments.docs.map((doc) => ({...doc.data(), id: doc.id})));
      }

    async function deleteComment() {
        const newsDoc = doc(database, "news", newsIdSelected, "comments", selectedComment);
        await deleteDoc(newsDoc);
        decreaseCommentsCounter(newsIdSelected, -1);
        setNewDataComments(true);
        closePopupDeleteComment(newsIdSelected);
        AlertBox(SUCCESS, '¡Comentario eliminado correctamente!');
    }

    async function decreaseCommentsCounter(newsId, counter) {
        const newsCollectionRef = doc(database, "news", newsId);
        await updateDoc(newsCollectionRef, {countComments: increment(counter)});
      }
    /*
    Getting all news comments
    */
    useEffect(() => {
        const interval = setInterval(() => {

        if (newDataComments && newsIdSelected) {
            const commentsCollectionRef = collection(database, "news", newsIdSelected, "comments");
            const getAllComments = async() => {
            const data = await getDocs(commentsCollectionRef);
            setSelectedNewsComments(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
            }
            getAllComments();
            setNewDataComments(!newDataComments);
        }
        }, WAIT_TIME);
        return () => clearInterval(interval);
    }, [selectedNewsComments, newDataComments, newsIdSelected])

    /*
    Gets all news documents
    */
    useEffect(() => {
        if (notInitialRender.current && newData){
            AlertOnLoading(WAIT_TIME+100);
        }else {
            notInitialRender.current = true;
        } 
        const interval = setInterval(() => {
            if (newData) {
                const allNewsRef = collection(database, "news");
                
                const getNews = async() => {
                    const data = await getDocs(allNewsRef);
                    setAllNews(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
                }
                getNews();
                setNewData(!newData);

                }/* else { // Checks whether the user did a search or not
                    var documents = sessionStorage.getItem("allDocuments");

                    if (documents == null) {
                        console.log("No hay documentos");
                        console.log(documents);

                    } else {
                        documents = JSON.parse(documents);
                        console.log("Los documentos:", documents);
                        setAllNews(documents);
                        setNewData(false);
                        
                    }
                }*/

            }, WAIT_TIME);
            return () => clearInterval(interval);
    }, [allNews, newData])

    /*
        Main webpage code
    */
  return (
    
    <div>
        <div>
        <Toaster
        toastOptions={{
            duration:3000,
        }}/>

        </div>

        <NavbarReturn />
        <div className='w-full h-navbar-mobile sm:h-navbar'></div>

        <div className='px-4 py-6 flex flex-col w-full h-0 bg-white lg:py-8'>
            <h2 className='lg:text-xl'>Agregar una Noticia</h2>
            <span className='lg:w-80 w-48 border border-primary-100'></span>
        </div>
        
        <div className='px-4 py-0 w-full h-auto flex flex-row bg-white'>

            <div className='flex flex-col space-y-4 px-4 py-6 '>

                <div>
                    <input onChange={(event) => {setNewsTitle(event.target.value)}} value={newsTitle} type={"text"} placeholder="Título"
                        className='text-sm md:text-base w-60 sm:w-64 md:w-72 lg:w-input-web h-input-height py-2 px-3 text-input-font bg-primary-300
                        focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>
                </div>

                <div>
                    <div className='relative h-input-height w-60 sm:w-64 md:w-72 lg:w-input-web py-2 px-3 overflow-hidden
                        text-input-font bg-primary-300 focus:outline-none 
                        focus:border focus:border-primary-100 focus:shadow-md'>
                        <div className='w-36 sm:w-52 md:w-60 lg:w-80 overflow-hidden'>
                            <label htmlFor="file" id="fileName" className={`${imageSelected==="Imagen"? "text-placeholder":"text-input-font"} text-sm md:text-base`}>{imageSelected}</label>
                        </div>

                        <div className='absolute inset-y-0 right-0 flex items-center'>
                            <ArrowUpTrayIcon className={`${imageSelected==="Imagen"? "text-placeholder":"text-input-font"} h-4 w-4 md:h-5 md:w-5 mx-2 hover:cursor-pointer`} />
                        </div>

                        <input onChange={updateText} id="uploadImage" className='w-full absolute file:w-full opacity-0 cursor-pointer left-0 -top-0 h-input-height' 
                        aria-hidden='true' type={"file"} accept=".jpeg, .jpg, .png, .webp, .svg"/>
                    </div>
                </div>

                <div className='sm:hidden'>
                    <textarea  className='h-20 py-2 px-3 w-60 sm:w-64 md:w-72 lg:w-input-web sm:hidden text-sm sm:text-base text-input-font bg-primary-300
                    focus:outline-none focus:border focus:border-primary-100 focus:shadow-md resize-none' 
                    id="description" name="description" rows="7" cols="41" placeholder="Descripción"
                    onChange={(event) => {setNewsDescription(event.target.value)}} value={newsDescription}></textarea>
                </div>

                <div>
                    <button id="addRegister"
                    className='h-8 w-60 sm:w-64 md:w-72 lg:w-input-web text-sm sm:text-base sm:h-9 bg-primary-100 mt-0 text-white rounded font-bold form1:text-xl hover:bg-primary-200 disabled:bg-primary-200'
                    onClick={createNews}>
                        {!uploading? 
                        "Agregar"
                        : 
                        <div className="w-full flex justify-center items-center"> 
                            <svg fill='none' className="w-6 h-6 sm:w-8 sm:h-8 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                            <path clipRule='evenodd'
                                d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                                fill='currentColor' fillRule='evenodd' />
                            </svg> 
                            Agregando
                        </div>}
                    </button>
                </div>

                <div>
                    <button className='sm:hidden w-60 sm:w-64 h-8 text-sm bg-primary-100 text-white rounded font-bold form1:text-xl hover:bg-primary-200'
                    onClick={togglePopUp}>Previsualizar</button>
                </div>

            </div>

            <div className='hidden sm:flex sm:flex-col sm:h-32 sm:space-y-2.5 sm:px-4 sm:py-6 sm:w-80 bg-white'>
            
                <div>
                    <textarea className='py-2 px-3 w-48 sm:w-64 md:w-72 lg:w-input-web h-text-area-height text-sm sm:text-base text-input-font bg-primary-300
                            focus:outline-none focus:border focus:border-primary-100 focus:shadow-md resize-none'
                            id="description" name="description" rows="3" cols="41" placeholder="Descripción"
                            onChange={(event) => {setNewsDescription(event.target.value)}} value={newsDescription}></textarea>
                </div>

                <div>
                    <button className='sm:w-64 md:w-72 lg:w-input-web h-8 text-sm sm:text-base sm:h-9  bg-primary-100 text-white rounded font-bold form1:text-xl hover:bg-primary-200'
                    onClick={togglePopUp}>Previsualizar</button>
                </div>

            </div>

        </div>

        <div className='px-4 flex flex-col w-full h-full bg-white'>
            <h2 className='lg:text-xl mt-10'>Todas las Noticias</h2>
            <span className='lg:w-80 w-48 border border-primary-100'></span>
            <div className={`${allNews? "block":"hidden"}`}>
                <SearchBar options={["Antiguos", "Recientes"]} allDocs={allNews}/>
            </div>
            
        </div>

        <div className='w-full flex flex-row justify-center bg-white pb-6 min-h-[60vh]'>
            <div className='w-full flex flex-col justify-center items-center bg-white'>
                {allNews? allNews.slice(firstNewsIndex, lastNewsIndex).map((news)=> (
                    <div className='w-full flex justify-center' key={news.id}>
                        <div className='max-w-table-web w-4/5 p-2 gap-2 grid grid-rows-9 mt-6 border border-primary-100 md:flex md:flex-col'>
                            <div className='hidden md:grid grid-cols-2 gap-2'>
                                
                                <div className='flex flex-col space-y-2'>
                                    <div className='bg-primary-300 w-full h-9 flex justify-center items-center'>
                                        <h3 className='text-primary-100 text-sm lg:text-lg'>Título y Descripción</h3>
                                    </div>

                                    <div className='bg-background w-full h-9 flex justify-center items-center'>
                                        <p className='text-navFont-100 text-base lg:text-xl font-bold'>{news.title}</p>
                                    </div>

                                    <div className='bg-background w-full h-24 overflow-y-auto flex justify-center'>
                                        <p className='text-navFont-100 text-sm lg:text-lg text-center'>{news.description}</p>
                                    </div>

                                    <div className='bg-primary-300 w-full h-9 flex justify-center items-center'>
                                        <h3 className='text-primary-100 text-sm lg:text-lg'>Fecha</h3>
                                    </div>

                                    <div className='bg-background w-full h-9 flex justify-center items-center'>
                                        <p className='text-navFont-100 text-sm lg:text-lg'>{news.date}</p>
                                    </div>

                                    <div className='bg-primary-300 w-full h-9 flex justify-center items-center'>
                                        <h3 className='text-primary-100 text-sm lg:text-lg'>Acción</h3>
                                    </div>

                                    <div className='w-full h-9 flex justify-center items-center bg-background space-x-2'>

                                        <div className='w-1/3'>
                                            <button onClick={() => {togglePopUpNews(news.id, news.title, news.image, news.description)}}
                                            className='w-full h-7 text-sm lg:text-base sm:h-9 bg-primary-100 text-white rounded-md font-bold hover:bg-primary-200'>Editar Noticia</button>
                                        </div>
                                        
                                        <div className='w-1/3'>
                                            <button onClick={() => {togglePopUpComments(news.id)}}
                                            className='w-full h-7 text-sm lg:text-base sm:h-9 bg-success text-white rounded-md font-bold'>Comentarios</button>
                                        </div>

                                        <div className='w-1/3 flex items-end'>
                                            <button onClick={() => {togglePopupDelete(news.id)}} 
                                            className='w-full h-7 text-sm lg:text-base sm:h-9 bg-danger text-white rounded-md font-bold hover:bg-red-400'>Eliminar Noticia</button>
                                        </div>

                                    </div>
                                </div>

                                <div className='flex flex-col space-y-2'>
                                    <div className='bg-primary-300 w-full h-9 flex justify-center items-center'>
                                        <h3 className='text-primary-100 text-sm lg:text-lg'>Imagen</h3>
                                    </div>

                                    <div className='bg-slate-600 w-full h-full flex justify-center items-center max-h-[315px]'>
                                        <LazyLoadImage src={news.image} className='w-full h-full max-h-80 object-cover lg:object-fit'
                                        alt=''></LazyLoadImage>
                                    </div>
                                </div>
                            </div>
                            
                            <div className='md:hidden bg-primary-300 w-full h-9 flex justify-center items-center'>
                                <h3 className='text-primary-100 text-sm'>Título y Descripción</h3>
                            </div>

                            <div className='md:hidden bg-background w-full h-9 flex justify-center items-center'>
                                <h3 className='text-navFont-100 text-base font-bold'>{news.title}</h3>
                            </div>

                            <div className='md:hidden bg-background w-full h-24 overflow-y-auto flex justify-center'>
                                <p className='w-full text-center text-sm h-auto text-navFont-100'>
                                    {news.description}
                                </p>
                            </div>
                            
                            <div className='md:hidden bg-primary-300 w-full h-9 flex justify-center items-center'>
                                <h3 className='text-primary-100 text-sm'>Fecha</h3>
                            </div>

                            <div className='md:hidden bg-background w-full h-9 flex justify-center items-center'>
                                <h3 className='text-navFont-100 text-base font-sm'>{news.date}</h3>
                            </div>

                            <div className='md:hidden bg-primary-300 w-full h-9 flex justify-center items-center'>
                                <h3 className='text-primary-100 text-sm'>Imagen</h3>
                            </div>

                            <div className='md:hidden bg-slate-600 w-full h-auto flex justify-center items-center'>
                                <LazyLoadImage src={news.image} className='w-full h-auto max-h-60 object-cover'
                                alt=''></LazyLoadImage>
                            </div>

                            <div className='md:hidden bg-primary-300 w-full h-9 flex justify-center items-center'>
                                <h3 className='text-primary-100 text-sm'>Acción</h3>
                            </div>

                            <div className='md:hidden w-full h-9 flex justify-center items-center bg-background space-x-2'>

                                <div className='bg-background w-1/2 h-9 flex justify-center items-center'>
                                    <button onClick={() => {togglePopUpNews(news.id, news.title, news.image, news.description)}}
                                    className='w-full h-9 text-sm lg:text-base sm:h-9 bg-primary-100 text-white rounded-md font-bold hover:bg-primary-200'>Editar Noticia</button>
                                </div>

                                <div className='bg-background w-1/2 h-9 flex justify-center items-center'>
                                    <button onClick={() => {togglePopUpComments(news.id)}}
                                    className='w-full h-9 text-xs form0:text-sm lg:text-base sm:h-9 bg-success hover:bg-green-400 text-white rounded-md font-bold'>Comentarios</button>
                                </div>

                                <div className='bg-background w-1/2 h-9 flex justify-center items-center'>
                                    <button onClick={() => {togglePopupDelete(news.id)}}
                                    className='w-full h-9 text-sm lg:text-base sm:h-9 bg-danger text-white rounded-md font-bold hover:bg-red-400'>Eliminar Noticia</button>
                                </div>

                            </div>
                        </div>

                        <div className={`hidden fixed backdrop-blur-sm mt-navbar-mobile bg-popup inset-0 z-30 items-center justify-center`} id={news.id}> 
                            <div className='relative sm:max-w-3xl w-full flex flex-col justify-center py-3 items-center mx-10 sm:mx-5 sm:px-3 h-auto bg-white rounded overflow-y-auto'>
                                <div className='w-full flex flex-col items-center justify-center mt-3'>
                                    <h2 className='flex flex-row md:text-xl'>Editar una Noticia </h2>
                                    <span className='md:w-80 w-48 h-px border border-primary-100'></span>
                                </div>
                                <button onClick={() => {closePopUpNews(news.id)}} className='absolute top-1 right-1 hover:text-primary-100'><XMarkIcon className='w-7 h-7'/></button>
                                <div className='sm:static sm:space-x-3 sm:items-start sm:flex-row relative w-full flex flex-col justify-center py-3 items-center mx-0 h-auto bg-white rounded overflow-y-auto'>
                                    <div className='w-full flex flex-col items-center justify-center'>
                                        

                                        <div className='w-52 mt-3 sm:w-5/6'>
                                            <input type={"text"} placeholder="Nombre" onChange={(ev) => {setNewsTitle(ev.target.value)}} value={newsTitle}
                                            className='md:text-base text-sm w-full h-8 py-2 px-3 text-input-font bg-primary-300
                                            focus:outline-none focus:border focus:border-primary-100 focus:shadow-md'/>
                                        </div>

                                        <div className='relative w-52 h-8 py-1 px-3 overflow-hidden sm:w-5/6
                                            text-input-font bg-primary-300 focus:outline-none 
                                            focus:border focus:border-primary-100 focus:shadow-md mt-3'>
                                            
                                            <div className='w-40 sm:w-52 md:w-60 lg:w-64 overflow-hidden'>
                                                <label htmlFor="file" id="fileName" className={`${imageSelected==="Imagen"? "text-placeholder":"text-input-font"} text-sm md:text-base`}>{imageSelected}</label>
                                            </div>

                                            <div className='absolute inset-y-0 right-0 flex items-center'>
                                                <ArrowUpTrayIcon className={`${imageSelected==="Imagen"? "text-placeholder":"text-input-font"} h-4 w-4 md:h-5 md:w-5 mx-2 hover:cursor-pointer`} />
                                            </div>
                                            <input onChange={updateTextPopUp} id="uploadImage" className='w-full absolute file:w-full opacity-0 cursor-pointer left-0 -top-0 h-8' 
                                            aria-hidden='true' type={"file"} accept=".jpeg, .jpg, .png, .webp, .svg" />
                                        </div>

                                        <div className='w-52 mt-1 flex flex-col bg-primary-300 py-2 px-3 sm:w-5/6'>
                                            <h4 className='sm:text-base text-sm text-input-font'>Imagen anterior:</h4>
                                            <LazyLoadImage src={imageURL} alt="">
                                            </LazyLoadImage>
                                        </div>

                                        <div className='sm:hidden w-52 mt-3'>
                                            <textarea className='md:text-base py-2 px-3 h-20 w-full text-sm text-input-font bg-primary-300
                                            focus:outline-none focus:border focus:border-primary-100 focus:shadow-md resize-none'
                                            onChange={(ev) => {setNewsDescription(ev.target.value)}} value={newsDescription}
                                            id="description" name="description" rows="7" cols="41" placeholder='Descripción'></textarea>
                                        </div>

                                    </div>

                                    <div className='hidden sm:flex sm:flex-col justify-center items-center w-full sm:space-y-2'>
                                        
                                        <div className='w-52 mt-3 sm:w-5/6'>
                                            <textarea className='md:text-base py-2 px-3 h-40 w-full text-sm text-input-font bg-primary-300
                                            focus:outline-none focus:border focus:border-primary-100 focus:shadow-md resize-none'
                                            onChange={(ev) => {setNewsDescription(ev.target.value)}} value={newsDescription}
                                            id="description" name="description" rows="7" cols="41" placeholder='Descripción'></textarea>
                                        </div>

                                    </div>
                                </div>
                                <div className='w-52 mt-3 flex flex-row'>
                                    <button onClick={updateNews} 
                                        className={`w-full h-8 text-sm sm:text-base sm:h-9 bg-primary-100 text-white rounded font-bold hover:bg-primary-200 disabled:bg-primary-200 ${deleteNumbers(news.id)}`}>
                                        {!updating? 
                                        "Guardar"
                                        : 
                                        <div className="w-full flex justify-center items-center"> 
                                            <svg fill='none' className="w-6 h-6 sm:w-8 sm:h-8 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                                            <path clipRule='evenodd'
                                                d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                                                fill='currentColor' fillRule='evenodd' />
                                            </svg> 
                                            Guardando
                                        </div>}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className={`hidden relative z-40 popup_delete ${news.id}`} aria-labelledby="modal-title" role="dialog" aria-modal="true" >
                            <div className="fixed inset-0 bg-popup"></div>

                            <div className="fixed inset-0 z-10 overflow-y-auto">
                                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                    <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                        <div className="sm:flex sm:items-start">
                                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                            <svg className="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 10.5v3.75m-9.303 3.376C1.83 19.126 2.914 21 4.645 21h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 4.88c-.866-1.501-3.032-1.501-3.898 0L2.697 17.626zM12 17.25h.007v.008H12v-.008z" />
                                            </svg>
                                        </div>
                                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                            <h3 className="text-lg font-medium leading-6 text-gray-900" id="modal-title">Eliminar Registro</h3>
                                            <div className="mt-2">
                                            <p className="text-sm text-gray-500">¿Está seguro que desea eliminar este registro? Este registro no se podrá recuperar. </p>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                        <button onClick={() => {deleteNews(news.id);}} type="button" className="inline-flex w-full justify-center rounded-md border border-transparent bg-danger px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-400 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm">Eliminar</button>
                                        <button onClick={() => {closePopupDelete(news.id);}} type="button" className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-100 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">Cancelar</button>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* PopUp para comentarios de noticia específica*/}
                        <div className={`hidden popup_comments ${news.id} pt-8 pb-8 fixed backdrop-blur-sm mt-navbar-mobile bg-popup inset-0 z-30 items-center justify-center`}>

                            <div className='relative w-full sm:w-form1 flex flex-col pb-8 mx-10 h-full bg-white rounded overflow-y-auto max-h-popup-mobile max-w-table-web'>

                                <button className='absolute top-1 right-1 hover:text-primary-100 bg-white opacity-90 rounded-full' onClick={() => {closePopupComments(news.id);}}><XMarkIcon className='w-8 h-8 md:w-10 md:h-10'/></button>

                                {/* Código para comentarios */}
                                <div className='w-full px-4 py-5 flex flex-col items-center'>
                                    <h2 className='text-center font-semibold text-black'>Comentarios</h2>
                                    <span className='w-1/2 border border-primary-100'></span>
                                </div>

                                {selectedNewsComments?.map((comment) => (
                                <div className='mt-10 w-full flex flex-row px-6 justify-start items-center space-x-4'>
                                    
                                    <div className='w-full flex flex-col justify-center items-center space-y-2 relative'>

                                        <div className='bg-primary-300 w-full h-24 flex flex-col justify-center items-start px-10'>
                                            <h3 className='text-justify text-black text-sm lg:text-lg'>{comment.comment}</h3>
                                            <h3 className='text-comment-autor text-sm lg:text-lg'>{comment.userName}</h3>
                                        </div>

                                        <button className='sm:hidden h-8 w-full text-sm bg-danger text-white rounded font-medium hover:bg-red-400'
                                                    onClick={() => {togglePopUpDeleteComment(news.id, comment.id)}}>Eliminar</button>

                                    </div>

                                    <div className='hidden sm:flex'>
                                        <button className='h-12 w-24 text-sm bg-danger text-white rounded font-medium hover:bg-red-400'
                                            onClick={() => {togglePopUpDeleteComment(news.id, comment.id)}}>Eliminar</button>
                                    </div>

                                </div>
                                ))}
                                {/* Cierra comentarios */}
                            </div>

                        </div>
                        
                        {/* PopUp para eliminar un comentario */}
                        <div className={`hidden relative z-40 popup_deletecomment ${news.id}`} aria-labelledby="modal-title" role="dialog" aria-modal="true" >
                            <div className="fixed inset-0 bg-popup"></div>

                            <div className="fixed inset-0 z-10 overflow-y-auto">
                                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                    <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                        <div className="sm:flex sm:items-start">
                                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                            <svg className="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 10.5v3.75m-9.303 3.376C1.83 19.126 2.914 21 4.645 21h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 4.88c-.866-1.501-3.032-1.501-3.898 0L2.697 17.626zM12 17.25h.007v.008H12v-.008z" />
                                            </svg>
                                        </div>
                                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                            <h3 className="text-lg font-medium leading-6 text-gray-900" id="modal-title">Eliminar Registro</h3>
                                            <div className="mt-2">
                                            <p className="text-sm text-gray-500">¿Está seguro que desea eliminar este registro? Este registro no se podrá recuperar. </p>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                        <button onClick={() => {deleteComment();}} type="button" className="inline-flex w-full justify-center rounded-md border border-transparent bg-danger px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-400 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm">Eliminar</button>
                                        <button onClick={() => {closePopupDeleteComment(news.id);}} type="button" className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-100 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">Cancelar</button>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                ))
                :
                <div className='w-full flex h-footer-height justify-center items-center text-4xl text-primary-100 space-x-1'>
                    <svg fill='none' className="w-14 h-14 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                        <path clipRule='evenodd'
                            d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                            fill='currentColor' fillRule='evenodd' />
                    </svg>
                    <div>
                        Cargando...
                    </div>
                </div>
                }

                <div className={`${allNews?.length? "flex" : "hidden"} w-full items-center justify-evenly mt-5`}>
                    <span className={`text-sm text-gray-700`}>
                        Mostrando <span className="font-semibold text-gray-900">{lastNewsIndex >= allNews?.length? allNews?.length:lastNewsIndex}</span> de <span className="font-semibold text-gray-900">{allNews?.length}</span> resultados
                    </span>
                    <div className="inline-flex mt-2 xs:mt-0">
                        <button
                            onClick={() => {setCurrentPage(currentPage - 1)}} 
                            className={`${currentPage === 1? "pointer-events-none bg-primary-300" : "text-white bg-primary-100 hover:bg-primary-200"} px-4 py-2 text-sm font-medium rounded-l`}>
                            Anterior
                        </button>
                        <button 
                            onClick={() => {setCurrentPage(currentPage + 1)}}
                            
                            className={`${lastNewsIndex >= allNews?.length? "pointer-events-none bg-primary-300" : "text-white bg-primary-100 hover:bg-primary-200"} px-4 py-2 text-sm font-medium border-0 border-l border-white rounded-r`}>
                            Siguiente
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div className={`${isOpen? "block":"hidden"} pt-8 pb-8 fixed backdrop-blur-sm mt-navbar-mobile bg-popup inset-0 z-30 flex items-center justify-center`}>

            <div className='relative w-full flex flex-col pb-8 mx-10 h-full bg-white rounded overflow-y-auto max-h-popup-mobile max-w-table-web min-w-[350px]'>

                <button className='absolute top-1 right-1 hover:text-primary-100 bg-white opacity-90 rounded-full' onClick={togglePopUp}><XMarkIcon className='w-8 h-8 md:w-10 md:h-10'/></button>

                <div className='w-full h-full max-h-80 items-center bg-slate-600'>
                    <LazyLoadImage
                        className='object-cover w-full h-full'
                        src={imageNotNull()}
                        alt='Imagen Noticia'>
                    </LazyLoadImage>
                </div>

                <div className='w-full flex flex-row px-3 py-4 space-x-2'>
                    <h2 className='text-xl lg:text-xl font-bold'>{newsTitle}</h2>
                    <CalendarIcon className='mt-1 text-zinc-600 w-5 h-5'/>
                    <h2 className='mt-1 text-sm text-zinc-600 lg:text-base'>{getCurrentDate()}</h2>
                </div>

                <div className='w-full px-4'>
                    <p readOnly className='overflow-auto resize-none w-full whitespace-pre-line'>{newsDescription}</p>
                    
                </div>

            </div>

        </div>

        <FooterAdmin />
    </div>
  )
}

export default NewsAdmin